<main class="d-flex min-vh-100" role="main">
    <app-sidebar></app-sidebar>
    <div class="flex-grow-1 p-4 bg-secondary">
        <router-outlet></router-outlet>
    </div>
</main>
<app-spinner-page></app-spinner-page>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-scroll-to-top></app-scroll-to-top>